<template>
  <div>
    <StaticDataTable class="static-table-list order-item-list table-sm" :striped="false" v-if="itemList">
      <template v-slot:header>
          <tr>
            <th>Item</th>
            <th>Info</th>
            <th>Quantity</th>
            <th>Size</th>
          </tr>
      </template>
      <template v-slot:body>
        <template v-for="(item, index) of itemList">
          <!-- Gap -->
          <tr v-if="index > 0 && item.isParentItem" class="order-item-sub-header" :key="`order-item-gap-${item.id}`">
            <td colspan="3"> </td>
          </tr>

          <tr :key="`order-item-${item.id}`" :class="['order-item-row', `order-item-row-group-${item.groupStockType}`, isItemCancelled(item) ? 'order-item-row-cancelled' : '']">
            <td class="order-item-type-details">
              <span v-if="isChildItem(item)"><span v-html="itemIndentDisplay(item)" /><i class="fas fa-caret-right fa-sm text-muted order-item-indent-arrow"></i>&nbsp;&nbsp;</span>
              {{item.stock.name}}
              <small v-if="item.generatedDescription" class="order-item-generated-description"><i class="fas fa-caret-right"></i> {{item.generatedDescription}}</small>
            </td>
            <td>{{itemPriceDescription(item)}}</td>
            <td>
              <span v-if="item.isBlock">{{item.blockQuantity}} Block{{displayCountPlural(item.blockQuantity)}}</span>
              <span v-if="!item.isBlock">{{item.quantity}}</span>
            </td>
            <td>
              <span v-if="itemIsGlass(item) || itemIsTemplate(item)">{{item.glassHeight}} x {{item.glassWidth}}</span>
            </td>
          </tr>
        </template>
      </template>
      </StaticDataTable>
  </div>
</template>


<script>
import { InventoryStockTypes } from '@/store/types'

export default {
  name: 'OrderItemPreviewList',
  props: {
    itemList: Array     // Note: Must be processed by OrderItemMixin.buildOrderItemList()
  },
  mounted() {
  },
  methods: {
    findRootParent(item) {
      var rootItem = null

      if(item.parentOrderItemId == null)
        return item

      this.itemList.forEach(parentItem => {
        if(parentItem.id == item.parentOrderItemId) {
          let root = this.findRootParent(parentItem)
          if(root)
            rootItem = root
        }
      })
      return rootItem
    },
    itemParent(item) {
      return this.itemList.find(parentItem => parentItem.id == item.parentOrderItemId)
    },
    isItemCancelled(item) {
      let rootParentItem = this.findRootParent(item)
      if(rootParentItem && rootParentItem.isCancelled)
        return true
      return item.isCancelled
    },
    itemIndentDisplay(item) {
      return '&nbsp;'.repeat(item.level * 2)
    },
    isChildItem(item) {
      return item.parentOrderItemId != null
    },
    itemIsGlass(item) {
      return item.stockType == InventoryStockTypes.glass
    },
    itemIsTemplate(item) {
      return item.stockType == InventoryStockTypes.template
    },
    itemPriceDescription(item) {
      var priceDescription = ''
      var parentItem = this.itemParent(item)

      // If this is a child item, fill in the service details from the parent
      if(item.stockType == InventoryStockTypes.glassService) {
        if(parentItem) {              
          var serviceRange = ''

          if(parentItem.stockPriceGroup && parentItem.stockPriceGroup.name) {
            priceDescription = parentItem.stockPriceGroup.name
          }
          if(parentItem.servicePriceRange && parentItem.servicePriceRange.name) {
            serviceRange = parentItem.servicePriceRange.name
          }
          if(item.servicePriceRange && item.servicePriceRange.name) {
            serviceRange = item.servicePriceRange.name
          }

          priceDescription += ` | ${serviceRange}`
        }

        return priceDescription
      }

      // Display delivery fee info for delivery item / min price item / min invoice item / cancel fee item
      if(item.isDeliveryItem || item.isMinPriceItem || item.isMinInvoiceItem || item.isCancelFeeItem) {
        return item.pricingDescription
      }

      if(item.stockPriceGroup && item.stockPriceGroup.name)
        return item.stockPriceGroup.name
      return '-'
    },
  }
}
</script>